import { useEffect, useState } from 'react'

import { Menu, TextInput } from '@mantine/core'
import { MXFlag, USFlag } from 'mantine-flagpack'

import IconChevronDown from 'src/icons/IconChevronDown'
import { CountryConfig } from 'src/lib/country.utils'
import {
  getCountryCode,
  formatPhone,
  formatMexicanPhoneNumberString,
  formatPhoneNumberString,
  removeCountryCode,
} from 'src/lib/phone.utils'

const PhoneInput = ({ hideCountrySelector = false, ...props }) => {
  const { value, onChange } = props
  const country = getCountryCode(value)
  const [countryCode, setCountryCode] = useState(
    hideCountrySelector
      ? CountryConfig.US.phoneCode
      : country || CountryConfig.US.phoneCode
  )
  const formattedPhone = formatPhone(value) //This removes the country code and formats the number accordingly
  const isMobile = window.innerWidth < 768
  const leftSectionWidth = hideCountrySelector ? '0px' : '80px'
  const leftSectionStyles = `flex flex-row items-center gap-1 text-nowrap px-2 font-medium text-doubleNickel-gray-400 hover:cursor-pointer ${
    isMobile ? 'text-lg' : 'text-sm'
  }`

  //If the country code changes, we reformat and save the new phone number
  useEffect(() => {
    if (!value) return
    let phone = removeCountryCode(value)
    if (countryCode === CountryConfig.MX.phoneCode) {
      phone = formatMexicanPhoneNumberString(phone)
    } else {
      phone = formatPhoneNumberString(phone)
    }
    phone = countryCode + phone
    onChange(phone)
  }, [countryCode])

  const countryConfig =
    Object.values(CountryConfig).find(
      (config) => config.phoneCode === countryCode
    ) || CountryConfig.US

  return (
    <TextInput
      placeholder={countryConfig.phoneFormatPlaceholder}
      leftSectionWidth={leftSectionWidth}
      leftSection={
        hideCountrySelector ? null : (
          <Menu width={200} shadow="md">
            <Menu.Target>
              <div className={leftSectionStyles}>
                {countryCode}
                <IconChevronDown className="h-4 fill-none stroke-doubleNickel-gray-400" />
              </div>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Item
                onClick={() => setCountryCode(CountryConfig.US.phoneCode)}
              >
                <div className="flex flex-row items-center gap-2">
                  <USFlag w={30} radius="lg" />
                  <div>United States ( {CountryConfig.US.phoneCode} )</div>
                </div>
              </Menu.Item>
              <Menu.Item
                onClick={() => setCountryCode(CountryConfig.MX.phoneCode)}
              >
                <div className="flex flex-row items-center gap-2">
                  <MXFlag w={30} radius="lg" />
                  <div>Mexico ( {CountryConfig.MX.phoneCode} )</div>
                </div>
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        )
      }
      {...props}
      value={formattedPhone}
      onChange={(event) => {
        if (
          (countryCode === CountryConfig.MX.phoneCode &&
            event.target.value.length > 12) ||
          (countryCode === CountryConfig.US.phoneCode &&
            event.target.value.length > 16)
        )
          return
        //This intercepts the input's changes and re-adds the country code before updating the parent
        const phone = event.target.value
        const result = phone === '' ? phone : countryCode + phone
        onChange(result)
      }}
    />
  )
}

export default PhoneInput
